import { LabelEdge } from './components/node-components';

export const edgeTypes = {
  labelEdge: LabelEdge,
};
